// Types
import { ProposalDAOInterface } from '../../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../../ProposalDAOImpl';
import { ComparisonItemDAO } from '../../ProposalItemDAO';
import * as ProposalNS from '../../../Proposal';
import * as ProposalElementNS from '../../../ProposalElements';
import { ProposalFieldDAO } from '../../ProposalFieldDAO';
import { ProposalStyleClassNames } from '../../../ProposalStyleClassNames';

// Components
import { CurrencyCell, NotApplicableCell } from '../../../../../views/components/cells';
import HTMLCell from '../../../../../views/components/cells/HTMLCell';

// Utils
import { SCENARIO_UNIT } from '../../../../../utils/income-stream';
import { getProposalDistributionScenarios } from '../../../utils/income-stream';

export default class IncomeStreamSummaryDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new IncomeStreamSummaryDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected build(): void {
    const itemDAOs: ComparisonItemDAO[] = this.getItemDAOs();

    // there should only be one item
    if (itemDAOs.length === 1) {
      const { item } = itemDAOs[0];

      if (item.scenarios !== undefined) {
        const { defaultIncomeStream } = item.scenarios;

        const capital = defaultIncomeStream ? defaultIncomeStream.capital : 0;
        const initialInvestmentTitle = this.formatMessage('Proposal.Modules.IncomeStream.InitialInvestment');
        this.addItemField(itemDAOs[0], initialInvestmentTitle, { value: capital }, CurrencyCell);

        const { incomeStreamDistribution } = item.scenarios;
        const distributionScenarios = getProposalDistributionScenarios(this.proposal.options.orientation, incomeStreamDistribution);

        for (let i = 0; i < distributionScenarios.length; i++) {
          const distributionScenario = distributionScenarios[i];
          const { type, amount, frequency, distributionHarvest, unit } = distributionScenario;
          const scenarioTitle = this.formatMessage('Proposal.Modules.IncomeStream.Scenario', { key: i + 1 });
          const typeString = this.formatMessage(`Comparison.IncomeStream.Form.Type.${type}`);
          const amountStr =
            unit === SCENARIO_UNIT.DOLLAR
              ? this.formatMessage('Comparison.IncomeStream.FormattedCurrency', { capital: this.formatNumber(amount) })
              : `${amount}%`;
          const frequencyStr = this.formatMessage(`Comparison.IncomeStream.Form.Frequency.${frequency}`);
          const harvestStr = distributionHarvest === 100 ? this.formatMessage('Comparison.IncomeStream.Form.DistributionsHarvested') : '';
          let str = '';
          if (amount !== 0) {
            str = `
              <span class="scenario-type">${typeString}:</span>
              <span class="scenario-amount">${amountStr} ${frequencyStr}</span>
            `;
          }
          str += `
              ${harvestStr && `<span class="harvest-distributions-text">${harvestStr}</span>`}
            `;
          this.addItemField(itemDAOs[0], scenarioTitle, str, HTMLCell);
        }
      }
    }
  }

  // private methods

  private addItemField(itemDAO: ComparisonItemDAO, name: string, value: string | { value: number }, cellType: any, classes: string[] = []): void {
    const field: ProposalFieldDAO = new ProposalFieldDAO(name, value, [ProposalStyleClassNames.ProposalTableContent, ...classes].join(' '));
    field.cellType = value != null ? cellType : NotApplicableCell;
    this.addFieldDAO(itemDAO, field);
    this.addFieldName(name, ProposalStyleClassNames.ProposalTableContent);
  }
}
